import type { Emitter } from 'mitt'
import mitt from 'mitt'

type Events = {
  showLoginDialog: string,
  logoutSuccess: string,
  loginSuccess: string,
  joinChatRoom: string,
  joinChatRoomFinished: string,
  scrollChatToBottom: string,
}

export const emitter: Emitter<Events> = mitt<Events>()
